import {
  ui,
  storage,
  device,
  link,
  net,
  envVar,
  i18n,
  region,
  message,
  envFn,
  cache,
  migrate,
  _money,
} from "@platform/index"
import { eventInit, pageDestoryListener } from "@platform/index"
import type { AppInfo } from "@typings/local"
import { globalInfo } from "../api/env/util"
import { isEmpty } from "../utils/index"
import { ErrorMsgMap } from "../utils/systemError"

declare let globalThis: any

const sn = cache?.get("__sn__") || undefined
if (!sn) {
  device.getSerialNumber().then((res) => {
    if (res) cache.set("__sn__", res)
  })
}

/**
 * 初始化DSL
 */
export const initDSL = function (config: {
  linkConfig?: Parameters<typeof link.init>[0]["getConfig"]
  serviceCall?: Parameters<typeof net.init>[0]["getConfig"]
  ui?: Parameters<typeof ui.init>[0]
  env?: string
  envMap?: Parameters<typeof envVar.init>[0]
  lang?: string
  defaultLang?: string
  langSupport?: string[]
  max?: Max
  shortKey?: string
  serviceCallEnv?: string
  appInfo?: AppInfo
  login?: Tlogin
  migrate?: Migrate
  moneyConfig?: AllMoneyConfig
  defaultCurrency?: TCurrency
  isAppWorker?: boolean
  officialCloudApi?: any[]
  overlayConfigs?: any[]
}) {
  const {
    linkConfig,
    serviceCall,
    ui: _ui,
    envMap,
    env,
    lang,
    defaultLang,
    langSupport,
    appInfo,
    login = {},
    migrate: _migrate,
    moneyConfig,
    defaultCurrency,
    isAppWorker = false,
    officialCloudApi = [],
    overlayConfigs
  } = config

  globalThis.__isAppWorker__ = isAppWorker

  globalInfo?.set("__isAppWorker__", isAppWorker)

  // 缓存浮层配置
  globalInfo?.set("overlayConfigs", overlayConfigs)
  // appWorker过滤不支持的TinyApi
  if (!isAppWorker) {
    eventInit()
    pageDestoryListener()
  }

  // 初始化iot相关配置
  linkConfig && link.init({ getConfig: linkConfig })

  // 初始化网络相关配置
  serviceCall && net.init({ getConfig: serviceCall, officialApi: officialCloudApi }, config?.serviceCallEnv, _migrate)

  // 初始化ui相关配置
  ui.init(_ui)

  // 初始化localStorage
  storage.init()

  // 初始化环境变量相关配置
  envMap && envVar.init(envMap)

  // 初始化环境相关配置
  env && envFn.setEnv(env)

  // 端侧同步变量给运行时
  if (__platform === "android") {
    envMap && TinyAPI?.envVar?.setEnvList!(Object.keys(envMap))
  }

  // 初始化应用相关信息
  if (!isEmpty(appInfo)) {
    if (appInfo?.region && appInfo?.regionServerSupportedMap) {
      region.init(appInfo?.region, appInfo?.regionServerSupportedMap) // 设置默认region
    }
    globalInfo.init(appInfo) // 初始化app Info

    // 端侧底层会帮助处理message init
    if (__platform !== "android") {
      message.init({
        // 初始化message
        appId: appInfo?.appId,
        tenantCode: appInfo?.tenantCode,
        env: env,
        serviceCallEnv: config?.serviceCallEnv,
      })
    }

    _migrate && migrate.init(_migrate, appInfo?.tenantCode, env)
  }

  // 是否开启sunmi登录鉴权
  if (Object.keys(login).length) {
    globalInfo?.set?.("login", login)
  }

  // 初始化多语言相关配置
  langSupport && i18n.setLangList(langSupport)
  lang && defaultLang && i18n.init(lang, defaultLang)

  // 设置系统国际化错误词条
  if (lang) {
    if (__platform === "android") {
      const errorMsg =
        ErrorMsgMap[["en-US", "zh-CN"].includes(lang) ? lang : "en-US"]
      TinyAPI.iot.setLanguageMsg && TinyAPI.iot.setLanguageMsg(errorMsg, lang)
    }
  }

  // 初始化money相关配置
  defaultCurrency &&
    !isEmpty(moneyConfig) &&
    _money.init({ moneyConfig, defaultCurrency })
}
